/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputUavMissionSortie
 */
export interface OutputUavMissionSortie {
    /**
     * 
     * @type {string}
     * @memberof OutputUavMissionSortie
     */
    closedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputUavMissionSortie
     */
    crossedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputUavMissionSortie
     */
    lastAltitudeM?: number;
    /**
     * LastPlace/LastAltitudeM — остання доповідь про положення («Затишне 400 м»).
     * @type {string}
     * @memberof OutputUavMissionSortie
     */
    lastPlace?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputUavMissionSortie
     */
    lastReportedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputUavMissionSortie
     */
    launchedAt: string;
    /**
     * 
     * @type {string}
     * @memberof OutputUavMissionSortie
     */
    posAt?: string;
    /**
     * PosDist/PosAt — позиція з останньої доповіді (метри вздовж треку, RFC3339). null — борт
     * летить від моменту пуску.
     * @type {number}
     * @memberof OutputUavMissionSortie
     */
    posDist?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputUavMissionSortie
     */
    seq: number;
    /**
     * Status — airborne | beyond_contact_line | lost | landed.
     * @type {string}
     * @memberof OutputUavMissionSortie
     */
    status: string;
}

/**
 * Check if a given object implements the OutputUavMissionSortie interface.
 */
export function instanceOfOutputUavMissionSortie(value: object): boolean {
    if (!('launchedAt' in value)) return false;
    if (!('seq' in value)) return false;
    if (!('status' in value)) return false;
    return true;
}

export function OutputUavMissionSortieFromJSON(json: any): OutputUavMissionSortie {
    return OutputUavMissionSortieFromJSONTyped(json, false);
}

export function OutputUavMissionSortieFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputUavMissionSortie {
    if (json == null) {
        return json;
    }
    return {
        
        'closedAt': json['closedAt'] == null ? undefined : json['closedAt'],
        'crossedAt': json['crossedAt'] == null ? undefined : json['crossedAt'],
        'lastAltitudeM': json['lastAltitudeM'] == null ? undefined : json['lastAltitudeM'],
        'lastPlace': json['lastPlace'] == null ? undefined : json['lastPlace'],
        'lastReportedAt': json['lastReportedAt'] == null ? undefined : json['lastReportedAt'],
        'launchedAt': json['launchedAt'],
        'posAt': json['posAt'] == null ? undefined : json['posAt'],
        'posDist': json['posDist'] == null ? undefined : json['posDist'],
        'seq': json['seq'],
        'status': json['status'],
    };
}

export function OutputUavMissionSortieToJSON(value?: OutputUavMissionSortie | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'closedAt': value['closedAt'],
        'crossedAt': value['crossedAt'],
        'lastAltitudeM': value['lastAltitudeM'],
        'lastPlace': value['lastPlace'],
        'lastReportedAt': value['lastReportedAt'],
        'launchedAt': value['launchedAt'],
        'posAt': value['posAt'],
        'posDist': value['posDist'],
        'seq': value['seq'],
        'status': value['status'],
    };
}

